(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onRefresh = this.onRefresh.bind(this);
    }

    connectedCallback() {
      // Event delegation on the root survives content re-renders
      this.addEventListener('click', (event) => this.onClick(event));
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('cart:refresh', this.onRefresh);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('cart:refresh', this.onRefresh);
      document.body.style.overflow = '';
    }

    onDocumentClick(event) {
      const trigger = event.target.closest('[data-cart-drawer-open]');
      if (trigger) {
        event.preventDefault();
        this.open();
      }
    }

    onClick(event) {
      if (event.target.closest('[data-cart-drawer-close]') || event.target.closest('[data-cart-drawer-backdrop]')) {
        this.close();
        return;
      }
      const qty = event.target.closest('[data-cart-qty]');
      if (qty) {
        this.changeLine(Number(qty.dataset.line), Number(qty.dataset.quantity));
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    onRefresh(event) {
      this.refresh(event.detail && event.detail.open);
    }

    open() {
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.querySelector('.cart-drawer__panel').focus();
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    changeLine(line, quantity) {
      this.classList.add('is-loading');
      fetch(this.dataset.changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then((response) => response.json())
        .then(() => this.refresh(false))
        .catch(() => this.classList.remove('is-loading'));
    }

    refresh(openAfter) {
      this.classList.add('is-loading');
      fetch(this.dataset.rootUrl + '?sections=cart-drawer')
        .then((response) => response.json())
        .then((sections) => {
          const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const fresh = doc.querySelector('[data-cart-drawer-content]');
          const current = this.querySelector('[data-cart-drawer-content]');
          if (fresh && current) current.replaceWith(fresh);

          const count = fresh ? Number(fresh.dataset.itemCount) : 0;
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = count;
            el.toggleAttribute('hidden', count === 0);
          });

          this.classList.remove('is-loading');
          if (openAfter) this.open();
        })
        .catch(() => this.classList.remove('is-loading'));
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class FooterLocalization extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('[data-locale-select]');
      const form = this.querySelector('form');
      if (select && form) {
        select.addEventListener('change', () => form.submit());
      }
    }
  }

  if (!customElements.get('footer-localization')) {
    customElements.define('footer-localization', FooterLocalization);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderNav extends HTMLElement {
    constructor() {
      super();
      this.onDocClick = this.onDocClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    onResize() {
      this.measureAnnouncement();
    }

    connectedCallback() {
      this.dropdowns = Array.from(this.querySelectorAll('.header__nav-item--has-dropdown'));
      this.dropdowns.forEach((item) => {
        const trigger = item.querySelector('[data-dropdown-trigger]');
        trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleDropdown(item);
        });
      });

      this.mobileToggle = this.querySelector('[data-mobile-toggle]');
      this.mobileNav = this.querySelector('[data-mobile-nav]');
      if (this.mobileToggle && this.mobileNav) {
        this.mobileToggle.addEventListener('click', () => this.toggleMobile());
      }

      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKeydown);

      // Transparent mode: only when the FIRST section of the page opts in
      // (e.g. the hero's "transparent header" setting).
      const firstSection = document.querySelector('#MainContent .shopify-section:first-child');
      if (firstSection && firstSection.querySelector('[data-allow-transparent-header]')) {
        this.classList.add('header--transparent');
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        // Transparent mode takes the header out of the flow (position:
        // fixed), so an announcement bar above it would sit underneath
        // the header instead of pushing it down. Offset the header by
        // the bar's measured height — measured, not hard-coded, since
        // the bar's text wraps to two lines on narrow screens.
        this.announcementBar = document.querySelector('[data-announcement-bar]');
        if (this.announcementBar) {
          this.measureAnnouncement();
          window.addEventListener('resize', this.onResize, { passive: true });
        }
      }
    }

    measureAnnouncement() {
      this.announcementHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
      this.offsetForAnnouncement();
    }

    // The bar scrolls away with the page while the header is fixed, so
    // the offset has to shrink as it goes — otherwise the header hovers
    // below an empty strip once the bar is gone. Ride up with the bar,
    // then dock at the top.
    offsetForAnnouncement() {
      if (!this.announcementBar) return;
      const top = Math.max(0, this.announcementHeight - window.scrollY);
      if (top === this.lastAnnouncementOffset) return;
      this.style.top = top + 'px';
      this.lastAnnouncementOffset = top;
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    onScroll() {
      this.classList.toggle('is-scrolled', window.scrollY > 24);
      this.offsetForAnnouncement();
    }

    toggleDropdown(item) {
      const isOpen = item.classList.contains('is-open');
      this.closeAllDropdowns();
      if (!isOpen) {
        item.classList.add('is-open');
        item.querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'true');
      }
    }

    closeAllDropdowns() {
      this.dropdowns.forEach((item) => {
        item.classList.remove('is-open');
        item.querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'false');
      });
    }

    toggleMobile() {
      const willOpen = this.mobileNav.hasAttribute('hidden');
      this.mobileNav.toggleAttribute('hidden', !willOpen);
      this.mobileToggle.setAttribute('aria-expanded', String(willOpen));
      this.classList.toggle('is-menu-open', willOpen);
    }

    onDocClick(e) {
      if (!this.contains(e.target)) this.closeAllDropdowns();
    }

    onKeydown(e) {
      if (e.key === 'Escape') this.closeAllDropdowns();
    }
  }

  if (!customElements.get('header-nav')) {
    customElements.define('header-nav', HeaderNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBlockDeselect = this.onBlockDeselect.bind(this);
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.hero__dot'));
      this.index = 0;
      if (this.slides.length < 2) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.slideTo));
          this.restartAutoplay();
        });
      });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.hasAttribute('data-autoplay') && !reducedMotion) {
        this.interval = Number(this.dataset.interval) || 6000;
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        this.startAutoplay();
      }

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    goTo(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll('a, button').forEach((el) => {
          if (active) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        if (i === this.index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    startAutoplay() {
      if (!this.interval || this.timer) return;
      this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      if (!this.interval) return;
      this.stopAutoplay();
      this.startAutoplay();
    }

    onBlockSelect(event) {
      const slideIndex = this.slides.indexOf(event.target.closest('.hero__slide'));
      if (slideIndex === -1) return;
      this.stopAutoplay();
      this.goTo(slideIndex);
    }

    onBlockDeselect() {
      this.startAutoplay();
    }
  }

  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  class CustomerAddresses extends HTMLElement {
    connectedCallback() {
      this.forms = {};
      this.querySelectorAll('[data-form]').forEach((el) => {
        this.forms[el.dataset.form] = el;
      });

      this.querySelectorAll('[data-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => this.open(btn.dataset.toggle));
      });
      this.querySelectorAll('[data-cancel]').forEach((btn) => {
        btn.addEventListener('click', () => this.close(btn.dataset.cancel));
      });
      this.querySelectorAll('[data-delete]').forEach((btn) => {
        btn.addEventListener('click', () => this.remove(btn));
      });

      // Preselect each saved address's country (country_option_tags defaults
      // to the shop country, which is wrong for editing existing addresses).
      this.querySelectorAll('[data-address-country]').forEach((node) => {
        const select = this.querySelector('#' + node.dataset.addressCountry);
        const country = JSON.parse(node.textContent || '""');
        if (select && country) select.value = country;
      });
    }

    open(name) {
      const el = this.forms[name];
      if (el) el.hidden = false;
    }

    close(name) {
      const el = this.forms[name];
      if (el) el.hidden = true;
    }

    remove(btn) {
      if (!window.confirm(btn.dataset.confirm)) return;
      const form = document.createElement('form');
      form.method = 'post';
      form.action = btn.dataset.delete;
      const method = document.createElement('input');
      method.type = 'hidden';
      method.name = '_method';
      method.value = 'delete';
      form.appendChild(method);
      document.body.appendChild(form);
      form.submit();
    }
  }

  if (!customElements.get('customer-addresses')) {
    customElements.define('customer-addresses', CustomerAddresses);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  class LoginToggle extends HTMLElement {
    constructor() {
      super();
      this.syncFromHash = this.syncFromHash.bind(this);
    }

    connectedCallback() {
      this.panels = {};
      this.querySelectorAll('[data-panel]').forEach((p) => {
        this.panels[p.dataset.panel] = p;
      });
      // If the recover form was submitted, Shopify reloads with the success
      // message inside the recover panel — keep it visible in that case.
      this.hasRecoverSuccess = !!this.querySelector('[data-panel="recover"] .customer__success');
      window.addEventListener('hashchange', this.syncFromHash);
      this.syncFromHash();
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.syncFromHash);
    }

    syncFromHash() {
      const wantRecover = window.location.hash === '#recover' || this.hasRecoverSuccess;
      this.show(wantRecover ? 'recover' : 'login');
    }

    show(name) {
      Object.entries(this.panels).forEach(([key, panel]) => {
        panel.toggleAttribute('hidden', key !== name);
      });
    }
  }

  if (!customElements.get('login-toggle')) {
    customElements.define('login-toggle', LoginToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    constructor() {
      super();
      this.onKeydown = this.onKeydown.bind(this);
      this.onTrackScroll = this.onTrackScroll.bind(this);
    }

    connectedCallback() {
      // Mobile dots: track the swipe position, jump on tap. Images are
      // 100% wide with no gap there, so the index is scrollLeft/width.
      this.track = this.querySelector('.product__media');
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      if (this.track && this.dots.length) {
        this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.scrollToSlide(Number(dot.dataset.galleryDot)));
        });
      }

      this.lightbox = this.querySelector('[data-lightbox]');
      if (!this.lightbox) return;

      this.slides = Array.from(this.querySelectorAll('[data-lightbox-slide]'));
      this.index = this.slides.findIndex((slide) => slide.hasAttribute('data-is-active'));
      if (this.index === -1) this.index = 0;

      this.querySelectorAll('[data-lightbox-open]').forEach((btn) => {
        btn.addEventListener('click', () => this.open(Number(btn.dataset.lightboxOpen)));
      });
      this.querySelectorAll('[data-lightbox-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });
      this.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-lightbox-next]')?.addEventListener('click', () => this.step(1));
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.body.style.overflow = '';
      if (this.track) this.track.removeEventListener('scroll', this.onTrackScroll);
      if (this.dotFrame) cancelAnimationFrame(this.dotFrame);
    }

    onTrackScroll() {
      if (this.dotFrame) return;
      this.dotFrame = requestAnimationFrame(() => {
        this.dotFrame = null;
        const width = this.track.clientWidth;
        if (width) this.setActiveDot(Math.round(this.track.scrollLeft / width));
      });
    }

    setActiveDot(index) {
      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    scrollToSlide(index) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({
        left: index * this.track.clientWidth,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    open(index) {
      this.lastFocus = document.activeElement;
      this.goTo(index);
      this.lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
      this.lightbox.querySelector('[data-lightbox-close]').focus();
    }

    close() {
      this.lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
      if (this.lastFocus) this.lastFocus.focus();
    }

    step(delta) {
      this.goTo(this.index + delta);
    }

    goTo(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.toggleAttribute('data-is-active', i === this.index);
      });
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
      if (event.key === 'ArrowLeft') this.step(-1);
      if (event.key === 'ArrowRight') this.step(1);
    }
  }

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('[data-option-group]'));
      this.variantSelect = this.querySelector('[data-variant-select]');
      this.priceEl = this.closest('.product__details').querySelector('[data-price]');
      // Deliberately `button.` — the pre-launch stand-in reuses the
      // .product__add class for its looks but is not a button, and
      // must not be treated as one here.
      this.addButton = this.querySelector('button.product__add');
      this.variants = JSON.parse(this.querySelector('[data-variant-json]')?.textContent || '[]');

      this.groups.forEach((group) =>
        group.addEventListener('change', () => this.onOptionChange())
      );

      this.form = this.querySelector('form');
      if (!this.form) return;

      // Pre-launch mode renders no Add to cart button. Block the form
      // outright then, so no stray submit path (Enter in a field, an
      // autofilled form) can put the item in the cart before launch.
      if (!this.addButton) {
        this.form.addEventListener('submit', (event) => event.preventDefault());
        return;
      }

      // Add to cart via AJAX and open the cart drawer instead of
      // navigating to the cart page (falls back to normal submit
      // when no drawer is present).
      if (document.querySelector('cart-drawer')) {
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
      }
    }

    onSubmit(event) {
      event.preventDefault();
      const previousLabel = this.addButton.textContent;
      this.addButton.disabled = true;

      fetch(this.form.action + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(this.form)
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) throw new Error(data.description || data.message || 'Error');
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        })
        .catch((error) => window.alert(error.message))
        .finally(() => {
          this.addButton.disabled = false;
          this.addButton.textContent = previousLabel;
        });
    }

    onOptionChange() {
      const chosen = this.groups.map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      const match = this.variants.find((v) =>
        v.options.every((opt, i) => opt === chosen[i])
      );
      if (!match) return;

      this.variantSelect.value = match.id;
      if (this.priceEl) this.priceEl.innerHTML = match.price_html;
      if (this.addButton) {
        this.addButton.disabled = !match.available;
        this.addButton.textContent = match.available ? match.add_label : match.sold_out_label;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
  }

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.querySelector('[data-qty-minus]').addEventListener('click', () => this.step(-1));
      this.querySelector('[data-qty-plus]').addEventListener('click', () => this.step(1));
    }

    step(delta) {
      const min = Number(this.input.min) || 1;
      const next = (Number(this.input.value) || min) + delta;
      this.input.value = Math.max(min, next);
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  class ProductDrawers extends HTMLElement {
    constructor() {
      super();
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.backdrop = this.querySelector('[data-drawer-backdrop]');
      if (!this.backdrop) return;
      this.panels = {};
      this.querySelectorAll('[data-drawer-panel]').forEach((panel) => {
        this.panels[panel.dataset.drawerPanel] = panel;
        panel.querySelector('[data-drawer-close]').addEventListener('click', () => this.close());
      });
      this.querySelectorAll('[data-drawer-open]').forEach((row) => {
        row.addEventListener('click', () => this.open(row.dataset.drawerOpen, row));
      });
      this.backdrop.addEventListener('click', () => this.close());
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.body.style.overflow = '';
    }

    open(id, trigger) {
      this.activePanel = this.panels[id];
      if (!this.activePanel) return;
      this.lastFocus = trigger;
      this.activePanel.classList.add('is-open');
      this.backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.activePanel.focus();
    }

    close() {
      if (!this.activePanel) return;
      this.activePanel.classList.remove('is-open');
      this.backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
      this.activePanel = null;
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  if (!customElements.get('product-drawers')) customElements.define('product-drawers', ProductDrawers);

  } catch(e) { console.error(e); }
})();
})();
